/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 112
// module chunks = 1